
const defaultState = {
  isLoading: true,
  pageSize: 5,
  currentPage: 1,
  products: [],
};

const products = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECEIVE_PRODUCTS':
      return Object.assign({}, state, {
        isLoading: false,
        products: [...state.products, ...action.products],
      });
    case 'REQUEST_PRODUCTS':
      return Object.assign({}, state, {
        isLoading: true,
        products: [...state.products],
      });
    case 'UPDATE_PAGE':
      return Object.assign({}, state, {
        currentPage: action.pageNumber,
        products: [...state.products],
      });
    default:
      return state;
  }
};

export default products;
